import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";

const industryRows = [
  {
    title: "Oil & Gas Exploration",
    text: "Upstream exploration support, rig-ready crews, and technical specialists for conventional and challenging wells.",
    link: "/service/oil-and-gas-exploration",
  },
  {
    title: "Offshore Platforms",
    text: "Mobilisation planning, marine operations alignment, and experienced personnel for platform drilling and maintenance cycles.",
    link: "/services",
  },
  {
    title: "Onshore Fields",
    text: "Land rig operations, workover campaigns, and field services scaled to basin-specific requirements.",
    link: "/services",
  },
  {
    title: "Energy Infrastructure",
    text: "Power generation, compression, and critical equipment support tied to production and midstream uptime.",
    link: "/services",
  },
  {
    title: "Petrochemical Industry",
    text: "Shutdown-ready manpower, maintenance disciplines, and HSE-aligned staffing for process-intensive sites.",
    link: "/contact",
  },
];

const Industries = () => (
  <Fragment>
    <MetaTags>
      <title>Industries & Solutions | South Asia Consultancy</title>
      <meta
        name="description"
        content="Oil and gas exploration, offshore platforms, onshore fields, energy infrastructure, and petrochemical workforce solutions from South Asia Consultancy."
      />
    </MetaTags>
    <LayoutOne>
      <SectionHeroBanner title="Industries & Solutions" className="sectionServicesBg" />
      <div className="container py-5 sac-page-shell">
        <MainTitle text="Where We Deliver" className="text-center" position="center" width="200px" />
        <p className="text-center fs18px fw500 mb-5 sac-intro">
          Sector-focused deployment models improve safety, mobilisation speed, and operational continuity across exploration,
          production, and infrastructure programmes.
        </p>
        <div className="row">
          {industryRows.map((row) => (
            <div key={row.title} className="col-md-6 mb-4">
              <div className="sac-content-card h-100">
                <h2 className="MainTitle" style={{ fontSize: "22px" }}>
                  {row.title}
                </h2>
                <p className="fs16px lnh-28">{row.text}</p>
                <Link to={row.link} className="color-primary read-more-underline fw600">
                  Explore capabilities
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </LayoutOne>
  </Fragment>
);

export default Industries;
